import { render } from "./EmbedSocialNetowrkSegment.vue?vue&type=template&id=045b40e2"
import script from "./EmbedSocialNetowrkSegment.vue?vue&type=script&lang=js"
export * from "./EmbedSocialNetowrkSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__